import { render, staticRenderFns } from "./TestPlanCasesView.vue?vue&type=template&id=db87956c&scoped=true&"
import script from "./TestPlanCasesView.vue?vue&type=script&lang=js&"
export * from "./TestPlanCasesView.vue?vue&type=script&lang=js&"
import style0 from "./TestPlanCasesView.vue?vue&type=style&index=0&id=db87956c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db87956c",
  null
  
)

export default component.exports